export default "__VITE_ASSET__BeCnOlzx__"